import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 33"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "currentColor",
        "fill-rule": "nonzero",
        d: "M8.808 22.278c.185.66.877 1.047 1.546.865a1.24 1.24 0 0 0 .877-1.525zM6.413 9.068l1.211-.331zm-2.301-2.24-.336 1.195zM1.593 4.85a1.26 1.26 0 0 0-1.547.864c-.185.66.206 1.343.875 1.526zM30.059 23.04a1.24 1.24 0 0 0 .9-1.512 1.26 1.26 0 0 0-1.532-.888zM13.318 26.07c.519 1.853-.62 3.808-2.637 4.325l.632 2.4c3.313-.85 5.337-4.137 4.428-7.385zm-2.637 4.325c-2.03.52-4.068-.642-4.591-2.51l-2.423.66c.905 3.232 4.346 5.097 7.646 4.25zm-4.591-2.51c-.52-1.853.62-3.808 2.637-4.326l-.632-2.4c-3.313.85-5.338 4.138-4.428 7.386zm2.637-4.326c2.03-.52 4.068.643 4.591 2.511l2.423-.66c-.905-3.233-4.347-5.097-7.646-4.251zm2.504-1.942L7.624 8.737l-2.422.66 3.606 12.881zM4.448 5.633 1.593 4.85l-.672 2.39 2.855.782zm3.176 3.104C7.2 7.222 5.984 6.053 4.448 5.633l-.672 2.39c.713.195 1.244.726 1.426 1.374zm7.221 18.204L30.06 23.04l-.632-2.4-15.214 3.9z"
      }),
      _createElementVNode("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-width": "2.513",
        d: "M28.343 7.35c-.812-2.903-1.219-4.354-2.413-5.014-1.195-.66-2.712-.271-5.745.506l-3.217.825c-3.033.778-4.55 1.167-5.239 2.31s-.283 2.595.53 5.498l.861 3.078c.813 2.903 1.22 4.354 2.414 5.014s2.711.272 5.744-.506l3.217-.825c3.033-.778 4.55-1.167 5.24-2.31.379-.628.427-1.349.258-2.352"
      })
    ], -1)
  ]))]))
}
export default { render: render }